module.exports = __webpack_public_path__ + "templates.basic-popover-e849fc18.html";